import fetch from 'isomorphic-fetch';

import {ApolloClient, InMemoryCache, createHttpLink} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {UMF_ADMIN_TOKEN} from '../constants/constants';

const httpLink = createHttpLink({
  uri: process.env.GATSBY_APP_SERVER,
  fetch,
  credentials: 'include',
});

const excludedPaths = ['/app/login'];

const authLink = setContext((_, {headers}) => {
  // return the headers to the context so httpLink can read them
  const token = localStorage.getItem(UMF_ADMIN_TOKEN);
  const currentUrl = window.location.pathname;

  // Function to check if the current URL matches any of the excluded paths
  const isExcludedPath = (currentUrl: string, excludedPaths: string[]) => {
    return excludedPaths.some(path => currentUrl === path);
  };

  const isNotExcludedPath = !isExcludedPath(currentUrl, excludedPaths);

  return {
    headers: {
      ...headers,
      authorization: token && isNotExcludedPath ? `Bearer ${token}` : '',
    },
  };
});

const cacheOptions = {
  typePolicies: {},
};

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

export default client;
